"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APIGetJournalRequestSchema = exports.APIUpsertJournalRequestSchema = void 0;
const zod_1 = require("zod");
const skin_1 = require("../constants/skin");
// ===== BASE SCHEMA =====
exports.APIUpsertJournalRequestSchema = zod_1.z.object({
    scanId: zod_1.z.string(),
    // Accept both new key-based tags and legacy translated strings for backward compatibility
    tags: zod_1.z.array(zod_1.z.union([zod_1.z.enum(skin_1.journalTagKeyEnum), zod_1.z.string()])).optional(),
    notes: zod_1.z.string().optional(),
});
// ===== GET JOURNAL REQUEST =====
exports.APIGetJournalRequestSchema = zod_1.z.object({
    scanId: zod_1.z.string(),
});
//# sourceMappingURL=user_skin_journal.js.map